<template>
  <div class="article-education-center__wrapper">
    <section-title :to="$options.consts.linkToEducationCenter">
      Education Center
    </section-title>

    <ul>
      <li
        v-for="article in articles.slice(0, 2)"
        :key="article.id"
        class="article-education-center__list-item"
      >
        <article-slot
          :article="article"
          :topic-line-count="2"
          :topic-line-height="22"
          :fixed-height="false"
        />
      </li>
    </ul>
  </div>
</template>
<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import SectionTitle from '../SectionTitle'
import ArticleSlot from 'shared/ArticleSlots/Fm/Shared/AArticleSlotEducationCenter'
import { ROUTE_NAME } from 'enums/routes'
import { SPECIAL_CATEGORY } from 'enums/special-categories'

export default {
  name: 'SidebarEducationCenter',
  components: { ArticleSlot, SectionTitle },
  props: {
    articles: propValidator([PROP_TYPES.ARRAY])
  },
  consts: {
    linkToEducationCenter: {
      name: ROUTE_NAME.CATEGORY_EDUCATION_CENTER,
      params: {
        category: SPECIAL_CATEGORY.FOREX
      }
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style scoped lang="scss">
.article-education-center__wrapper {
  .article-education-center__list-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
